// extracted by mini-css-extract-plugin
export var fullHeightState = "_4g-7";
export var headerCell = "_4g-1";
export var loadingStateCell = "_4g-4";
export var rowWrapper = "_4g-3";
export var standaloneTable = "_4g-8";
export var standaloneTableWithBodyFill = "_4g-9";
export var stateCell = "_4g-5";
export var table = "_4g-0";
export var tableBodyFiller = "_4g-6";
export var white = "_4g-2";